import { render, staticRenderFns } from "./display-text-data.vue?vue&type=template&id=2a39d2b8&"
import script from "./display-text-data.vue?vue&type=script&lang=js&"
export * from "./display-text-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports